import {RouteName} from '@toolify/client/src/setup/router/enum/RouteName'
import {
  INotificationResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/INotificationResponseInstance'
import {NotificationType} from '@toolify/server/src/models/mongoose/NotificationModel/enum/NotificationType'
import {RouteLocationRaw} from 'vue-router'
import {getNotificationWorkspaceName} from './getNotificationWorkspaceName'
import {isNotificationsPageEnabled} from '@toolify/client/src/modules/notifications/constants/isNotificationsPageEnabled'

export function getNotificationDetailsRoute(notification: INotificationResponseInstance<NotificationType>): RouteLocationRaw | null {
  if (!isNotificationsPageEnabled) {
    return null
  }

  const workspaceName = getNotificationWorkspaceName(notification)
  if (!workspaceName) {
    return null
  }

  return {
    name: RouteName.Notification,
    params: {
      workspaceName,
      notificationId: notification.id,
    },
  }
}
